module.exports = __webpack_public_path__ + "media/common/interview-feature2@2x-f5d2210f.png";